/* eslint-disable no-param-reassign */
import { pick } from 'underscore';

export function fetchAd({
  edm,
  jsData,
  scope,
}) {
  const {
    adId,
  } = scope;
  const params = {
    query: {
      entitySet: edm.currentAccount
        .Ads['Default.GridData']
        .$call({
          gridDataParameters: {},
        })
        .toJSON(),
      $count: true,
      $top: 1,
      $expand: 'Campaign($select=CampaignSettings,CampaignSubType,CampaignType,ExperimentId,Id),Labels',
      $filter: `Id eq ${adId}`,
      $select: 'DeliveryStatus,DeliveryStatusDetails,DisplayUrl,FinalUrlSuffix,FinalUrls,Id,MobileFinalUrls,Model.ResponsiveAd/BusinessName,Model.ResponsiveAd/CallToAction,Model.ResponsiveAd/CallToActionLanguage,Model.ResponsiveAd/Descriptions,Model.ResponsiveAd/Headline,Model.ResponsiveAd/Headlines,Model.ResponsiveAd/HotSpots,Model.ResponsiveAd/Images,Model.ResponsiveAd/ImpressionTrackingUrls,Model.ResponsiveAd/LandscapeImageMediaId,Model.ResponsiveAd/LandscapeImageMediaUrl,Model.ResponsiveAd/LandscapeLogoMediaId,Model.ResponsiveAd/LandscapeLogoMediaUrl,Model.ResponsiveAd/LongHeadline,Model.ResponsiveAd/LongHeadlines,Model.ResponsiveAd/SquareImageMediaId,Model.ResponsiveAd/SquareImageMediaUrl,Model.ResponsiveAd/SquareLogoMediaId,Model.ResponsiveAd/SquareLogoMediaUrl,Model.ResponsiveAd/Videos,Model.ResponsiveSearchAd/Descriptions,Model.ResponsiveSearchAd/Headlines,Status,Text,TextPart2,TrackingUrlTemplate,Type,UrlCustomParameters,Path1,Path2,DestinationUrl,DevicePreference,Title,TitlePart1,TitlePart2,TitlePart3',
    },
  };
  const options = {
    cacheResponse: false,
  };
  return jsData.Ad.findAll(params, options);
}

export function processAssets(ad, updated, fieldName, fieldNameMap) {
  const result = pick(ad, Object.values(fieldNameMap));

  result[fieldNameMap[fieldName]].map((item) => {
    if (item.Asset.IdString === updated.Id) {
      item.Asset.Text = updated[fieldName];
    }
    return item;
  });
  return result;
}

